import { Component, inject, input } from '@angular/core';
import { Product } from '@mwe/models';
import { HeadlineService } from '../../../headline/headline.service';
import { ProductTariffCardTemplateComponent } from '../../tariff-card-template/product-tariff-card-template.component';
import { InfoboxComponent } from '../../../infobox/infobox.component';

@Component({
  selector: 'mwe-tariff-card-internet',
  templateUrl: './tariff-card-internet.component.html',
  providers: [HeadlineService],
  imports: [ProductTariffCardTemplateComponent, InfoboxComponent],
})
export class TariffCardInternetComponent {
  product = input.required<Product>();

  headlineService = inject(HeadlineService);
}
